import { studentResources } from "../../constants/apiUrl";
import { IApiResponse } from "../../models/IAPIResponse";
import APIService from "../../helper/api-service";
import { urlBinder } from "../../helper/url-binder";
import { IStudentResourceData, IStudentResources } from "../../models/master/studentResource";

 export default new (class StudentResourceService {
  public getStudentResource = async (
    id: number
  ): Promise<IApiResponse<IStudentResourceData>> => {
    try {
      let endPoint = urlBinder(studentResources.GET_STUDENT_RESOURCE, [`${id}`]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<IStudentResourceData>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<IStudentResourceData>;
      } else {
        throw error;
      }
    }
  };

  public getStudentResources = async (
    configUserRole? : number
  ): Promise<IApiResponse<Array<IStudentResources>>> => {
    try {
      let endPoint = urlBinder(studentResources.GET_ALL_STUDENT_RESOURCES, [configUserRole]);
      const response = await APIService.get(endPoint);
      return response.data as IApiResponse<Array<IStudentResources>>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<Array<IStudentResources>>;
      } else {
        throw error;
      }
    }
  };

  public createStudentResource = async (
    data: any
  ): Promise<IApiResponse<boolean|any>> => {
    try {
      let endPoint = studentResources.CREATE_STUDENT_RESOURCE;
      const response = await APIService.postFormData(endPoint, data);
      return response.data as IApiResponse<boolean|any>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean|any>;
      } else {
        throw error;
      }
    }
  };

  public updateStudentResource = async (
    data: any,id:number
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = urlBinder(studentResources.UPDATE_STUDENT_RESOURCE, [`${id}`]);
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public updateStudentResourcePriority = async (
    data: any
  ): Promise<IApiResponse<boolean>> => {
    try {
      let endPoint = studentResources.UPDATE_STUDENT_RESOURCE_PRIORITY;
      const response = await APIService.put(endPoint, data);
      return response.data as IApiResponse<boolean>;
    } catch (error: any) {
      if (error.response) {
        return error.response as IApiResponse<boolean>;
      } else {
        throw error;
      }
    }
  };

  public deleteStudentResource = async (id: number): Promise<boolean> => {
    try {
      let endPoint = urlBinder(studentResources.DELETE_STUDENT_RESOURCE, [`${id}`]);
      const response = await APIService.delete(endPoint);
      return response.status === 204 ? true : false;
    } catch (error: any) {
      if (error.response) {
        return false as boolean;
      } else {
        throw error;
      }
    }
  };
})();
